/* eslint-disable import/no-anonymous-default-export */
import { SET_WINDOWS_TRANSPARENCY } from '../actionConstants';

export default (state = 85, action) => {
  switch (action.type) {
    case SET_WINDOWS_TRANSPARENCY:
      return action.payload;
    default:
      return state;
  }
};
